import type { BoxListItem } from "../../../api/WarehouseApi";
import { resolveEntityTypeTags } from "../../../utils/typeTags";
import { formatBoxReferenceInputValue } from "../../../utils/boxReference";

interface ReferenceData {
  availableBoxes: BoxListItem[];
  typeTagSuggestions: string[];
}

export function buildReferenceData(boxes: BoxListItem[]): ReferenceData {
  const tagSet = new Set<string>();

  boxes.forEach((box) => {
    resolveEntityTypeTags({
      typeTags: box.typeTags,
    }).forEach((tag) => tagSet.add(tag));
  });

  return {
    availableBoxes: boxes,
    typeTagSuggestions: Array.from(tagSet).sort(),
  };
}

export function formatParentInputValue(
  value: string,
  availableBoxes: BoxListItem[],
): string {
  return formatBoxReferenceInputValue(value, availableBoxes);
}
